import { Tag } from 'antd';
import { consignOrderBillingStatusConst } from '../../../../constants/ConsignOrderBilling.const';

export const ConsignOrderBillingStatus = ({ status }) => {
  const colors = {
    Pagada: 'green',
    Pendiente: 'warning',
    Cancelada: 'red',
  };

  return (
    <Tag color={colors[status] || consignOrderBillingStatusConst.DEFAULT}>
      {status || consignOrderBillingStatusConst.DEFAULT}
    </Tag>
  );
};
